import { getHttpStatus } from "@/utils/waajoFormsError";

export function canPublishForm(status) {
  return ["draft", "inactive"].indexOf(status) !== -1;
}

export function canDeactivateForm(status) {
  return status === "active";
}

export function isLifecycleConflict(error) {
  const status = getHttpStatus(error);
  return status === 404 || status === 406;
}

export function isLifecycleRetryable(error) {
  const status = getHttpStatus(error);
  return status === 0 || status >= 500;
}

export function getFormStatusLabel(status) {
  const labels = {
    draft: "Draft",
    active: "Aktif",
    inactive: "Nonaktif"
  };
  return labels[status] || "Tidak dikenal";
}

export function getFormStatusTone(status) {
  if (["draft", "active", "inactive"].indexOf(status) !== -1) {
    return status;
  }
  return "unknown";
}

export function getPublicBaseUrl() {
  const configured = process.env.VUE_APP_BASE_URL;
  const base =
    configured && String(configured).trim() !== ""
      ? String(configured).trim()
      : window.location.origin;
  return base.replace(/\/+$/, "");
}

export function getPublicFormUrl(formId) {
  return getPublicBaseUrl() + "/form/" + encodeURIComponent(formId || "");
}

export async function copyTextToClipboard(value) {
  const text = String(value || "");
  if (!text) {
    return false;
  }

  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return true;
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.top = "-9999px";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  textarea.setSelectionRange(0, textarea.value.length);
  const copied = document.execCommand("copy");
  document.body.removeChild(textarea);
  return copied;
}



// WEBPACK FOOTER //
// ./src/utils/waajoFormsLifecycle.js